import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContactInformationService } from '../../core/services/contact-information.service';

@Component({
    selector: 'app-pagetitle',
    templateUrl: './pagetitle.component.html',
    standalone: false
})

/**
 * Page Title Component
 */
export class PagetitleComponent {

  @Input()
  breadcrumbItems!: {
    active?: boolean;
    label?: string;
    link?: string;
  }[];
  showCard = false;
  @Input() title: string | undefined;

  constructor(private route: ActivatedRoute, private contactInformationService: ContactInformationService) {}

  isContactPage(): boolean {
    return this.route.snapshot.url[0].path === 'contact-information'; // Example for route check
  }

  hovered(isHovered: boolean): void {
    if (isHovered && this.isContactPage()) {
      this.contactInformationService.setShowLightCard(true);
    } else {
      this.contactInformationService.setShowLightCard(false);
    }
  }
}
